export default "__VITE_ASSET__CrssH0IX__"